import { QueuedOfflineError } from "@/api/client";
import type { ToastApi } from "@/components/toast-context";

/**
 * Report what happened to a mutation that did not return a result.
 *
 * A request kept for later is not a failure and must not read like one: the
 * saisie is safe, and telling someone their count failed when it did not is how
 * they end up counting twice. Everything else is reported as before.
 */
export function reportMutationError(toast: ToastApi, title: string, error: unknown): void {
  if (error instanceof QueuedOfflineError) {
    toast.info(
      "Enregistré hors ligne",
      "Sera synchronisé dès le retour du réseau. Rien n'est perdu.",
    );
    return;
  }
  toast.error(title, String(error));
}

/** True when the mutation was queued rather than refused. */
export function wasQueued(error: unknown): boolean {
  return error instanceof QueuedOfflineError;
}
